import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IWebinarsListFilterProps } from '../../../interfaces/props/IWebinarsListProps';
import TextBox from '../../../components/filters/textBox';
import DateRange from '../../../components/filters/dateRange';

type WebinarsListFilterPropsType = IWebinarsListFilterProps & WithTranslation;

class WebinarsListFilter extends Component<WebinarsListFilterPropsType> {

  public constructor(props: WebinarsListFilterPropsType) {
    super(props);
  }

  public render() {
    const {
      filter,
      isFetching,
      onNameChange,
      onSpeakersChange,
      onDateChange,
      onDescriptionChange,
      onVideoUrlChange,
      //onActiveChange,
      onFilterButtonClick,
      i18n
    } = this.props;

    return (
      <form onSubmit={(e: React.FormEvent) => { e.preventDefault(); onFilterButtonClick(); }}>
        <div className='row'>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('webinar.name')}</div>
                <TextBox
                  name='name'
                  value={filter.name}
                  showClearButton={true}
                  onChange={(value) => onNameChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('webinar.speakers')}</div>
                <TextBox
                  name='speakers'
                  value={filter.speakers}
                  showClearButton={true}
                  onChange={(value) => onSpeakersChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <DateRange
                name={i18n.t('webinar.date')}
                value={filter.date}
                i18n={i18n}
                onChangeInput={(value) => onDateChange(value)} />
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('webinar.description')}</div>
                <TextBox
                  name='description'
                  value={filter.description}
                  showClearButton={true}
                  onChange={(value) => onDescriptionChange(value)} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='form-group'>
              <div className='autocomplete-input'>
                <div className='autocomplete-label'>{i18n.t('webinar.videoUrl')}</div>
                <TextBox
                  name='videoUrl'
                  value={filter.videoUrl}
                  showClearButton={true}
                  onChange={(value) => onVideoUrlChange(value)} />
              </div>
            </div>
          </div>
        </div>
        <div className='row justify-content-end'>
          <div className='col-auto'>
            <button type='submit' className='btn btn-secondary' title={i18n.t('actions.filter')} disabled={isFetching}>
              {isFetching
                ? <span className='spinner-border spinner-border-sm' />
                : <span className='icon icon-app-item-search' />
              }
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default withTranslation()(WebinarsListFilter);
